export const obtenerValorTotal = (productos) => {

    let total = 0
    for (let i = 0; i < productos.length; i++) {
        let pedido = productos[i]
        let val = parseInt(pedido.valor) * parseInt(pedido.cantidad)
        total = total + val
    }

    return total

}